import _regeneratorRuntime from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import * as React from 'react';
import copy from 'copy-to-clipboard';
import { useEvent } from 'rc-util';
import toList from '../../_util/toList';
var useCopyClick = function useCopyClick(_ref) {
  var copyConfig = _ref.copyConfig,
    children = _ref.children;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    copied = _React$useState2[0],
    setCopied = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    copyLoading = _React$useState4[0],
    setCopyLoading = _React$useState4[1];
  var copyIdRef = React.useRef(null);
  var cleanCopyId = function cleanCopyId() {
    if (copyIdRef.current) {
      clearTimeout(copyIdRef.current);
    }
  };
  var copyOptions = {};
  if (copyConfig.format) {
    copyOptions.format = copyConfig.format;
  }
  React.useEffect(function () {
    return cleanCopyId;
  }, []);
  // Keep copy action up to date
  var onClick = useEvent(function (e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _a, text;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e === null || e === void 0 ? void 0 : e.preventDefault();
              e === null || e === void 0 ? void 0 : e.stopPropagation();
              setCopyLoading(true);
              _context.prev = 3;
              if (!(typeof copyConfig.text === 'function')) {
                _context.next = 10;
                break;
              }
              _context.next = 7;
              return copyConfig.text();
            case 7:
              _context.t0 = _context.sent;
              _context.next = 11;
              break;
            case 10:
              _context.t0 = copyConfig.text;
            case 11:
              text = _context.t0;
              copy(text || toList(children, true).join('') || '', copyOptions);
              setCopyLoading(false);
              setCopied(true);
              // Trigger tips update
              cleanCopyId();
              copyIdRef.current = setTimeout(function () {
                setCopied(false);
              }, 3000);
              (_a = copyConfig.onCopy) === null || _a === void 0 ? void 0 : _a.call(copyConfig, e);
              _context.next = 24;
              break;
            case 20:
              _context.prev = 20;
              _context.t1 = _context["catch"](3);
              setCopyLoading(false);
              throw _context.t1;
            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 20]]);
    }));
  });
  return {
    copied: copied,
    copyLoading: copyLoading,
    onClick: onClick
  };
};
export default useCopyClick;